import { z } from 'zod';

import { FileVisibility } from '../validators/component-sections/files';

export const FileSchema = z.object({
    id: z.string(),
    name: z.string(),
    group: z.string().default(''),
    prefix: z.string().default(''),
    updatedAt: z.string().datetime(),
    createdAt: z.string().datetime(),
    createdBy: z.any(), // todo
    url: z.string(),
    filename: z.string(),
    mimeType: z.string(),
    filesize: z.number(),
    width: z.number().optional(),
    height: z.number().optional(),
    pageCount: z.number().optional().nullable(),
});

export const FileUploadSchema = z.object({
    id: z.string(),
    file: FileSchema.shape.id,
});

export const CollectionWithFilesSchema = z.enum([
    'project',
    'design',
    'order',
    'teamComponent',
    'diagramComponentInstance',
]);

export const FilePayloadSchema = z.object({
    associateWith: CollectionWithFilesSchema,
    associatedId: z.string(),
    file: FileSchema.shape.id.optional(),
    url: z.string().optional(),
    diagramId: z.string().optional(),
    type: z.string(),
    folder: z.string().optional(),
});

export const CollectionFileSchema = z.object({
    id: z.string(),
    type: z.string(),
    visibility: z.nativeEnum(FileVisibility).optional().nullable().default(FileVisibility.PUBLIC),
    url: z.string().optional(),
    file: z.union([FileSchema, FileSchema.shape.id]).optional(),
});

export const CollectionFileSchemaWithFile = z.object({
    id: z.string(),
    type: z.string(),
    folder: z.string().optional(),
    url: z.string().optional(),
    file: FileSchema,
});

export const TeamComponentFileSchema = CollectionFileSchema.extend({
    componentId: z.string(),
});

export const DiagramComponentInstanceSchema = CollectionFileSchema.extend({
    componentInstanceId: z.string(),
});
